"use strict";
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Do NOT extend the functionality of this component beyond a UI element that displays
// a table of information with sorting capabilities. if you need to do anything extra (like add an extra element [like filtering data]), then
// create a new component for that and use this component.
//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = exports.TableSubtext = void 0;
const Table_pc_1 = require("./Table.pc");
Object.defineProperty(exports, "TableSubtext", { enumerable: true, get: function () { return Table_pc_1.TableSubtext; } });
const MoreMenu_1 = require("./MoreMenu");
const react_1 = __importStar(require("react"));
const ui_library_1 = require("@hum/ui-library");
const TableRows = ({ sortedData, itemKey, selectedRow, selectedRowRef, onRowClick = () => { }, labelKeys, cellConfig, onMenuItemClick, secondaryButton, getMenuItems, cellProps, wideCells, fixedCellWidth = false, nowrap, }) => {
    return sortedData.map((item, i) => {
        const value = item[itemKey];
        const selected = value === selectedRow;
        return (react_1.default.createElement(Table_pc_1.TableRow, { ref: selected ? selectedRowRef : undefined, key: value, selected: selected, onClick: () => onRowClick(value), testId: `table-row-${i}` }, labelKeys.map((key, i) => {
            const config = cellConfig[key];
            const cellStyle = fixedCellWidth
                ? {
                    maxWidth: `${100 / labelKeys.length}%`,
                }
                : {};
            if (config.style) {
                Object.assign(cellStyle, cellStyle);
            }
            return (react_1.default.createElement(Cell, { last: i === labelKeys.length - 1, extraProps: cellProps, key: key, propertyName: key, value: item[key], item: item, config: config, onMenuItemClick: onMenuItemClick, getMenuItems: getMenuItems, secondaryButton: secondaryButton, wideCells: wideCells, nowrap: nowrap, style: cellStyle }));
        })));
    });
};
exports.Table = (0, react_1.memo)(({ data, itemKey, style, onRowClick = () => { }, onMenuItemClick, getMenuItems, cellProps = {}, defaultSortKey, dontSortByDefault = false, cellConfig, wideCells = false, selectedRow, companyAnalyses = false, scrollToSelected = false, secondary = false, withChevron = false, fixedCellWidth = false, nowrap, secondaryButton, }) => {
    var _a;
    const labelKeys = Object.keys(cellConfig);
    const [sortKey, setSortKey] = (0, react_1.useState)(defaultSortKey || labelKeys[0]);
    const [ascending, setAscending] = (0, react_1.useState)(true);
    const getSortValue = ((_a = cellConfig[sortKey]) === null || _a === void 0 ? void 0 : _a.getSortValue) || getDefaultSortValue;
    // don't want to sort directly since that will mutate the original array -- might
    // point to a frozen object which would throw an exception.
    let sortedData = [...data];
    if (!dontSortByDefault) {
        sortedData = sortedData.sort((a, b) => {
            const order = ascending ? -1 : 1;
            return getSortValue(a, sortKey) > getSortValue(b, sortKey)
                ? -order
                : order;
        });
    }
    const includeScrollable = style === null || style === void 0 ? void 0 : style.hasOwnProperty('--scrollbar-height');
    const selectedRowRef = react_1.default.createRef();
    const scrollableRef = (0, react_1.useRef)(null);
    react_1.default.useLayoutEffect(() => {
        if (scrollToSelected) {
            autoScroll(selectedRowRef.current, scrollableRef.current);
        }
    }, [selectedRowRef.current, scrollableRef.current]);
    const tableRowProps = {
        sortedData,
        itemKey,
        selectedRow,
        selectedRowRef,
        onRowClick,
        labelKeys,
        cellProps,
        cellConfig,
        onMenuItemClick,
        getMenuItems,
        wideCells,
        fixedCellWidth,
        nowrap,
        secondaryButton,
    };
    const rows = react_1.default.createElement(TableRows, Object.assign({}, tableRowProps));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Table_pc_1.StyledTable, { companyAnalyses: companyAnalyses, secondary: secondary, withChevron: withChevron },
            react_1.default.createElement(Table_pc_1.TableRow, { header: true, testId: `table-header` }, labelKeys.map((key) => {
                const config = cellConfig[key];
                const isSortable = typeof config.getSortValue !== 'undefined';
                return (react_1.default.createElement(Table_pc_1.TableCell, { onClick: () => {
                        if (!isSortable) {
                            return;
                        }
                        if (sortKey === key) {
                            setAscending(!ascending);
                        }
                        else {
                            setSortKey(key);
                            setAscending(true);
                        }
                    }, sortable: isSortable, selected: sortKey === key, ascending: ascending, descending: !ascending, key: key, wideCells: wideCells }, config.label));
            })),
            react_1.default.createElement(Table_pc_1.TableDataRows, { style: style }, includeScrollable ? (react_1.default.createElement(ui_library_1.Scrollable, { ref: scrollableRef, children: rows })) : (rows)))));
});
exports.Table.displayName = 'Table';
const Cell = ({ onMenuItemClick, propertyName, value, item, extraProps, last, config, getMenuItems, wideCells, style, nowrap, secondaryButton, }) => {
    return (react_1.default.createElement(Table_pc_1.TableCell, { wideCells: wideCells, style: style, nowrap: nowrap },
        config.renderer
            ? react_1.default.createElement(config.renderer, Object.assign(Object.assign({}, extraProps), { item,
                propertyName }))
            : value,
        last &&
            getMenuItems &&
            (getMenuItems(item).length > 0 ? (react_1.default.createElement(MoreMenu_1.MoreMenu, { secondaryButton: secondaryButton }, getMenuItems(item).map((menuItem) => {
                return (react_1.default.createElement(MoreMenu_1.MoreMenuItem, { key: menuItem.value, onClick: () => {
                        onMenuItemClick && onMenuItemClick(menuItem.value, item);
                    } }, menuItem.label));
            }))) : null)));
};
const getDefaultSortValue = (item, key) => item[key];
function autoScroll(currentSelected, currentScrollable) {
    if (typeof window === 'undefined' ||
        !currentSelected ||
        !(currentScrollable === null || currentScrollable === void 0 ? void 0 : currentScrollable.contentElement))
        return;
    // prevent crash if ref is not there
    if (!currentSelected)
        return;
    // https://dev.to/n8tb1t/tracking-scroll-position-with-react-hooks-3bbj
    const currentSelecteats = currentSelected.getBoundingClientRect();
    const currentScrollableStats = currentScrollable.contentElement.getBoundingClientRect();
    window.setTimeout(() => {
        const y = currentSelecteats.bottom -
            (currentScrollableStats.top + currentScrollableStats.height);
        currentScrollable.scrollTo(undefined, y);
    });
}
//# sourceMappingURL=Table.js.map